import React from "react";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { useReveal } from "./hooks/useReveal";
import { useDisableInspect } from "./hooks/useDisableInspect";

import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Countdown from "./components/Countdown";
import MusicPlayer from "./components/MusicPlayer";
import OurStory from "./components/OurStory";
import MessageFromUs from "./components/MessageFromUs";
import Events from "./components/Events";
import Gallery from "./components/Gallery";
import ProposalVideo from "./components/ProposalVideo";
import Bio from "./components/Bio";
// import VenueMap from "./components/VenueMap";
import DressCode from "./components/DressCode";
import RSVP from "./components/RSVP";
import Gifts from "./components/Gifts";
import FAQ from "./components/FAQ";
// import GuestPacket from "./components/GuestPacket";
// import QRSection from "./components/QRSection";
import Footer from "./components/Footer";

export default function App() {
  useReveal();
  useDisableInspect();
  return (
    <>
      {/* Skip to content — accessibility */}
      <a
        href="#main"
        style={{
          position: "absolute",
          left: "-9999px",
          top: "6px",
          background: "#243C28",
          color: "#fff",
          padding: "8px 16px",
          borderRadius: "4px",
          zIndex: 9999,
          fontSize: "13px",
          textDecoration: "none",
        }}
        onFocus={(e) => {
          e.currentTarget.style.left = "16px";
        }}
        onBlur={(e) => {
          e.currentTarget.style.left = "-9999px";
        }}
      >
        Skip to main content
      </a>

      <ErrorBoundary>
        <Nav />
      </ErrorBoundary>
      <ErrorBoundary>
        <MusicPlayer />
      </ErrorBoundary>

      <main id="main">
        <ErrorBoundary>
          <Hero />
        </ErrorBoundary>
        <ErrorBoundary>
          <Countdown />
        </ErrorBoundary>
        <ErrorBoundary>
          <OurStory />
        </ErrorBoundary>
        <ErrorBoundary>
          <MessageFromUs />
        </ErrorBoundary>
        <ErrorBoundary>
          <Events />
        </ErrorBoundary>
        <ErrorBoundary>
          <Gallery />
        </ErrorBoundary>
        <ErrorBoundary>
          <ProposalVideo />
        </ErrorBoundary>
        <ErrorBoundary>
          <Bio />
        </ErrorBoundary>
        {/* <ErrorBoundary>
          <VenueMap />
        </ErrorBoundary> */}
        <ErrorBoundary>
          <DressCode />
        </ErrorBoundary>
        <ErrorBoundary>
          <RSVP />
        </ErrorBoundary>
        <ErrorBoundary>
          <Gifts />
        </ErrorBoundary>
        <ErrorBoundary>
          <FAQ />
        </ErrorBoundary>
        {/* <ErrorBoundary>
          <GuestPacket />
        </ErrorBoundary>
        <ErrorBoundary>
          <QRSection />
        </ErrorBoundary> */}
      </main>

      <ErrorBoundary>
        <Footer />
      </ErrorBoundary>
    </>
  );
}
